import { Button } from '@/components/ui/button';
import { useMyCapabilities } from '@/auth/capabilities';

/**
 * ko-admin#314 — the permissions request failed, and the operator is told so.
 *
 * The panel fails OPEN when `GET /admin/me/capabilities` does not answer: every
 * verdict is `unknown`, which shows the section, and the backend stays the
 * boundary. That is the right default — it is why it stays — but on its own
 * it was mute: a STAFF member saw the whole panel and got a 403 from every
 * section outside their profile, with nothing saying why. This bar is the why,
 * and a way out that does not need a reload.
 */
export function CapabilitiesErrorBanner() {
  const q = useMyCapabilities();
  if (!q.isError) return null;
  return (
    <div
      role="alert"
      className="flex items-center justify-between gap-4 border-b border-red/40 bg-red/10 px-6 py-2 text-sm text-red"
    >
      <span>No pude cargar tus permisos; algunas secciones pueden rechazarte.</span>
      <Button
        type="button"
        size="sm"
        variant="secondary"
        disabled={q.isFetching}
        onClick={() => void q.refetch()}
      >
        {q.isFetching ? 'Reintentando…' : 'Reintentar'}
      </Button>
    </div>
  );
}
